import type { CategoryExecutor } from './executor.types';
import { executeCalculationsNode } from './calculations.executor';
import { executeDecisionNode } from './decision.executor';
import { executeFlowControlNode } from './flow-control.executor';
import { executeFormsNode } from './forms.executor';
import { executeRulesNode } from './rules.executor';
import { executeValidationNode } from './validation.executor';
import {
  executeAiNode,
  executeApplicantNode,
  executeApprovalNode,
  executeCommunicationNode,
  executeCustomerNode,
  executeDataDisplayNode,
  executeDocumentsNode,
  executeHumanInteractionNode,
  executeIntegrationsNode,
  executeStorageNode,
  executeTasksNode,
  executeUtilityNode,
  executeVerificationNode,
  executeWorkflowNode,
} from './category.executors';

/** Category → executor. All 20 builder categories are registered. */
export const DEFAULT_CATEGORY_EXECUTORS: Record<string, CategoryExecutor> = {
  'flow-control': executeFlowControlNode,
  calculations: executeCalculationsNode,
  decision: executeDecisionNode,
  rules: executeRulesNode,
  validation: executeValidationNode,
  forms: executeFormsNode,
  applicant: executeApplicantNode,
  customer: executeCustomerNode,
  documents: executeDocumentsNode,
  verification: executeVerificationNode,
  integrations: executeIntegrationsNode,
  ai: executeAiNode,
  approval: executeApprovalNode,
  tasks: executeTasksNode,
  communication: executeCommunicationNode,
  storage: executeStorageNode,
  utility: executeUtilityNode,
  workflow: executeWorkflowNode,
  'human-interaction': executeHumanInteractionNode,
  'data-display': executeDataDisplayNode,
};
